module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-14.0ff81a09.png";